import { createContext } from 'react';
import { User } from '../types/user';

export const UserContext = createContext<{user: User, patchUser: any, setUser: any}>({user: null, patchUser: null, setUser: null});
